import styled from "styled-components";

export const ContainerStack = styled.div`
  background: ${({ theme }) => theme?.menu.main};
  display: flex;
  gap: 8px;
  border-radius: 8px;
  padding: 8px;
  max-width: max-content;
  box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.3);
`

export const TitleAndSubtitles = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 4px;
  color: ${({theme}) => theme?.text};
  letter-spacing: 2px;
`

export const ContainerIconStack = styled.div`
  display: flex;
  width: 60px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 6px;
  position: relative;
`
